import { Component, ElementRef, Inject, Injectable, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '@core/services/alert.service';
import { CommonService } from '@core/services/common.service';
import { ModalService } from '@core/services/modal.service';
import { TravelMemberService } from '@core/services/travel-member.service';
import { InsuredTripCancelRequest } from '@shared/models/policies/detail/insured-trip/insured-trip-cancel-request';
import { InsuredTripDetail } from '@shared/models/policies/detail/insured-trip/insured-trip-detail';
import { InsuredTripRequest } from '@shared/models/policies/detail/insured-trip/insured-trip-request';
import { InsuredTripTravelCardRequest } from '@shared/models/policies/detail/insured-trip/insured-trip-travel-card-request';
import { InsuredTripTravelCardResponse } from '@shared/models/policies/detail/insured-trip/insured-trip-travel-card-response';
import { InsuredTripUpdateRequest } from '@shared/models/policies/detail/insured-trip/insured-trip-update-request';
import moment, { isMoment, Moment } from 'moment';
import { BehaviorSubject } from 'rxjs';
import { InsuredTripsBaseComponent } from '../insured-trips-base.component';
import { InsuredTripChangeEndDateRequest } from '@shared/models/policies/detail/insured-trip/insured-trip-change-end-date-request';
import { Employee } from '@shared/models/policies/detail/employee/employee';
import { NxAutocompleteSelectedEvent } from '@aposin/ng-aquila/autocomplete';
import { EmployeeFormatPipe } from '@core/pipes/employee-format.pipe';
import { EmployeeService } from '@core/services/employee.service';
import { InsuredTripPartner } from '@shared/models/policies/detail/insured-trip/insured-trip-partner';
import { InsuredTrip } from '@shared/models/policies/detail/insured-trip/insured-trip';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@core/services/user.service';
import { LocaleService } from '@core/services/locale.service';
import { NX_DATE_LOCALE, NxDateAdapter, NxDatepickerInputEvent, NxDatepickerIntl } from '@aposin/ng-aquila/datefield';

@Injectable()
export class MyIntl extends NxDatepickerIntl {
    constructor(private translateService: TranslateService) {
        super();
        this.switchToMonthViewLabel = this.translateService.instant('common.date.month-view');
        this.switchToMultiYearViewLabel = this.translateService.instant('common.date.date-view');
    }
}

@Component({
    selector: 'app-edit-insured-trip',
    templateUrl: './edit-insured-trip.component.html',
    styleUrls: ['./edit-insured-trip.component.scss'],
    standalone: false
})
export class EditInsuredTripComponent extends InsuredTripsBaseComponent implements OnInit {
    @ViewChild('employeesInput') employeesInput: ElementRef<any>;

    public obsForm: BehaviorSubject<Boolean> = new BehaviorSubject(false);
    public insuredTripDetail: InsuredTripDetail = new InsuredTripDetail();
    public formEditInsuredTrip: FormGroup;

    private autocompleteEmployees: string[] = [];
    private employees: Array<Employee> = [];

    public showHasTravel = false;
    private policyNumber: string;
    private policyStatus: string;
    private policyNumberTravelMember: string;

    public canBeEdited = false;
    public canBeEditedDateEnd = false;
    public canBeCanceled = false;

    private partnerData: string = '';
    public hasTravel: {
        list: InsuredTrip[];
        allDataFlag: boolean;
    } = {
            allDataFlag: true,
            list: []
        };

    private selectedChangedEmployee: InsuredTripPartner | null = null;
    public dateEndStart: Moment;
    
    constructor(
        public commonService: CommonService,
        private route: ActivatedRoute,
        private router: Router,
        private modalService: ModalService,
        private travelMemberService: TravelMemberService,
        private alertService: AlertService,
        private employeeFormat: EmployeeFormatPipe,
        private employeeService: EmployeeService,
        private translateService: TranslateService,
        private userService: UserService,
        private localeService: LocaleService,
        @Inject(NX_DATE_LOCALE) private nxDateLocale: string,
        @Inject(NxDatepickerIntl) private intl: NxDatepickerIntl,
    ) {
        super(commonService);

        this.translateService.get('common.date.month-view').subscribe( x => {
            this.intl.switchToMonthViewLabel = x;
        })

        this.translateService.get('common.date.date-view').subscribe( x => {
            this.intl.switchToMultiYearViewLabel = x;
        })

        translateService.onLangChange.subscribe(x => {
            let lang = this.localeService.languages.find(y => y.code.toLowerCase() == x.lang);
            if (lang && lang.iso) {
                intl.switchToMonthViewLabel = translateService.instant('common.date.month-view');
                intl.switchToMultiYearViewLabel = translateService.instant('common.date.date-view');
                this.nxDateLocale = lang.iso;
            }
        });
    }

    ngOnInit(): void {
        this.route.params.subscribe(param => {
            if (param['policyNumber'] != undefined && param['policyNumber'].length > 0 &&
                param['status'] != undefined && param['status'].length > 0 &&
                param['policyNumberTravelMember'] != undefined && param['policyNumberTravelMember'].length > 0) {


                if (localStorage.getItem('changedEndDate')) {
                    localStorage.removeItem('changedEndDate');
                    this.alertService.clear();
                    this.translateService.get('policy.insured-trips.edit.date-changed').subscribe(msg => {
                        this.alertService.success(msg, {
                            autoClose: true
                        });
                    });
                }

                this.policyNumber = param['policyNumber'];
                this.policyStatus = param['status'];
                this.policyNumberTravelMember = param['policyNumberTravelMember'];
                this.travelMemberService.getTravelMemberDetail(this.policyNumber, this.policyNumberTravelMember)
                    .subscribe((insuredTripDetail) => {

                        // ak datum dateBegin je po aktulanom datume - uz je na tripe
                        this.canBeEdited = (insuredTripDetail.statusId == 4 &&
                            moment(insuredTripDetail.dateBegin).isSameOrAfter(moment.now(), 'days')) ? true : false;

                        // ak aktualny datum je pred datumom dateBegin
                        this.canBeCanceled = moment(moment.now()).isSameOrBefore(insuredTripDetail.dateBegin, 'days') && insuredTripDetail.statusId == 4 ? true : false;

                        this.canBeEditedDateEnd = (insuredTripDetail.statusId == 4 &&
                            moment(moment.now()).isAfter(insuredTripDetail.dateBegin, 'days') &&
                            moment(moment.now()).isSameOrBefore(moment(insuredTripDetail.dateEnd), 'days')) ? true : false;


                        this.employeeService.getEmployees(this.getLoggedUser().vatNumber).subscribe(employees => {
                            this.employees = employees;
                            employees.forEach((employee) => {
                                if (employee.canceledDate == undefined || employee.canceledDate == null) {
                                    this.autocompleteEmployees.push(employee.name + ';' + employee.surname + ';' + employee.dateOfBirth);
                                }
                            });
                        });

                        this.insuredTripDetail = insuredTripDetail;

                        this.obsForm.next(true);
                        this.initForm();
                    });
            }
        });
    }

    getEmployees(searchValue: string, transform: boolean = true): Array<string> {
        if (!searchValue) {
            //return [];
            return this.autocompleteEmployees;
        }

        return this.autocompleteEmployees.filter((item: string) => {
            return this.employeeFormat.transform(item.toLowerCase()).indexOf(searchValue.toLowerCase()) != -1;
        });
    }

    changedEmployeeHidden(): string {
        return this.formEditInsuredTrip.value.changedEmployee ? '' : 'hidden';
    }

    selectEmployee(selection: NxAutocompleteSelectedEvent) {
        this.selectedChangedEmployee = new InsuredTripPartner();
        const parsedOption = (selection.option.value as string).split(' ');
        this.selectedChangedEmployee.dateOfBirth = parsedOption[parsedOption.length - 1];
        parsedOption.pop();
        this.selectedChangedEmployee.surname = parsedOption[parsedOption.length - 1];
        parsedOption.pop();
        this.selectedChangedEmployee.firstName = parsedOption.join(' ');

        this.formEditInsuredTrip.patchValue({ changedEmployee: selection.option.value });

        selection.option.deselect();
        this.employeesInput.nativeElement.value = '';
        this.formEditInsuredTrip.markAsTouched();
    }

    deselectEmployee() {
        this.formEditInsuredTrip.controls.changedEmployee.patchValue(null);
        this.selectedChangedEmployee = null;
    }

    private initForm() {
        this.partnerData = this.insuredTripDetail.partner.firstName + ' ' +
            this.insuredTripDetail.partner.surname + ' ' + moment(this.insuredTripDetail.partner.dateOfBirth).format('DD.MM.YYYY');

        (this.formEditInsuredTrip = new FormGroup({
            dateBegin: new FormControl(
                {
                    value: moment(this.insuredTripDetail.dateBegin),
                    disabled: (!this.canBeEdited && this.canBeEditedDateEnd)
                },
                Validators.required
            ),
            dateEnd: new FormControl(moment(this.insuredTripDetail.dateEnd), Validators.required),
            partner: new FormControl({ value: this.partnerData, disabled: true }),
            changedEmployee: new FormControl({ value: '', disabled: true })
        })).valueChanges.subscribe((x) => {
            this.calculatePremium();
        });
    }

    cancelTrip() {
        if (!this.canBeCanceled) {
            return;
        }

        this.modalService.openModal('ConfirmInsuredTripCancelation').confirm.subscribe((submitEvent: SubmitEvent) => {
            if (submitEvent != null) {
                // DRY
                let insuredTripCancelRequest = new InsuredTripCancelRequest();
                insuredTripCancelRequest.cancelDate = moment(this.insuredTripDetail.dateBegin).format('YYYY-MM-DD');

                this.travelMemberService.cancelTravelMember(this.policyNumber, this.policyNumberTravelMember, insuredTripCancelRequest)
                    .subscribe((insuredTripCancelResponse) => {
                        if (insuredTripCancelResponse.success == true) {
                            this.router.navigate([`/moje-poistky/${this.policyStatus}/${this.policyNumber}/poistene-cesty`]);
                        }
                    });
            }
        });
    }

    updateTrip($event: SubmitEvent) {
        if (!this.formEditInsuredTrip.valid && this.canBeEditedDateEnd && !this.canBeEdited) {
            if (moment(this.insuredTripDetail.dateEnd).isSameOrBefore(this.formEditInsuredTrip.value.dateEnd, 'day')) {
                this.alertService.clear();
                this.alertService.warn(
                    'Pri predĺžení pracovnej cesty, dátum konca poistenia musí byť minimálne o 1 deň viac ako pôvodný.',
                    {
                        autoClose: true
                    }
                );
                return;
            }
        }

        if (!this.formEditInsuredTrip.valid || (!this.canBeEdited && !this.canBeEditedDateEnd)) {
            return;
        }


        let insuredTripRequest = new InsuredTripRequest();
        insuredTripRequest.dateBegin = moment(this.formEditInsuredTrip.value.dateBegin).format();
        insuredTripRequest.dateEnd = moment(this.formEditInsuredTrip.value.dateEnd).format();
        insuredTripRequest.dateSigned = moment().format();
        insuredTripRequest.zone = this.insuredTripDetail.zone;
        insuredTripRequest.premium = this.insuredTripDetail.premium;
        insuredTripRequest.tariff = this.insuredTripDetail.tariff;
        insuredTripRequest.partner.push(this.selectedChangedEmployee
            ? this.selectedChangedEmployee
            : this.insuredTripDetail.partner);

        insuredTripRequest.statusId = this.insuredTripDetail.statusId;

        // DRY
        let insuredTripCancelRequest = new InsuredTripCancelRequest();
        insuredTripCancelRequest.cancelDate = moment(this.insuredTripDetail.dateBegin).format('YYYY-MM-DD');

        let insuredTripUpdateRequest = new InsuredTripUpdateRequest();
        insuredTripUpdateRequest.insuredTripRequest = insuredTripRequest;
        insuredTripUpdateRequest.insuredTripCancelRequest = insuredTripCancelRequest;

        if (this.canBeEditedDateEnd && !this.canBeEdited) {
            // original dateEnd + 1 day
            insuredTripUpdateRequest.newDateBegin = moment(this.insuredTripDetail.dateEnd).add(1, 'day').format();
            insuredTripUpdateRequest.insuredTripRequest.partner = [this.insuredTripDetail.partner];
        }

        this.travelMemberService.updateTravelMember(
            this.policyNumber,
            this.policyNumberTravelMember,
            insuredTripUpdateRequest).subscribe((insuredTripResponses) => {
                this.showHasTravel = false;
                this.hasTravel = {
                    allDataFlag: true,
                    list: []
                };


                const firstKey = Object.keys(insuredTripResponses.results)[0];
                if (insuredTripRequest.partner.length === 1 && Object.keys(insuredTripResponses.results).length === 1) {
                    if (insuredTripResponses.results[firstKey].policyNumber) {
                        this.translateService.get('policy.insured-trips.show-new-travel', {
                            yes: `<a class="underlined" href="${this.commonService.getBaseHref()}moje-poistky/${this.policyStatus}/${this.policyNumber}/poistene-cesty/${insuredTripResponses.results[firstKey].policyNumber}">${this.translateService.instant('common.yes')}</a>`,
                            no: `<a class="underlined" href="${this.commonService.getBaseHref()}moje-poistky/${this.policyStatus}/${this.policyNumber}/poistene-cesty">${this.translateService.instant('common.no')}</a>`
                        }).subscribe(msg => {
                            this.alertService.info(msg);
                        });
                        return;
                    }
                }

                if (insuredTripResponses.results[firstKey].hasTravel.list.length) {
                    this.showHasTravel = true;
                    Object.keys(insuredTripResponses.results).forEach(key => {
                        this.hasTravel[key] = insuredTripResponses.results[key].hasTravel;
                    });
                    return;
                }

                this.router.navigate([`/moje-poistky/${this.policyStatus}/${this.policyNumber}/poistene-cesty`]);
            });
    }

    changedDateStart($event: NxDatepickerInputEvent<Moment>) {
        if($event.value.isValid()){
            this.dateEndStart = $event.value;
        }
    }

    filterDateBegin = (date: Moment): boolean => {
        if (date.isSameOrAfter(moment.now(), 'days') && (
            isMoment(this.formEditInsuredTrip.value.dateEnd) ?
                date.isSameOrBefore(this.formEditInsuredTrip.value.dateEnd, 'days') : true
        )) {
            return true;
        }

        return false;
    };

    filterDateEnd = (date: Moment): boolean => {
        if (date.isSameOrAfter(moment.now(), 'days') && (
            isMoment(this.formEditInsuredTrip.value.dateBegin) ?
                date.isSameOrAfter(this.formEditInsuredTrip.value.dateBegin) : true
        )) {
            return true;
        }

        return false;
    };

    generateTravelCard() {
        let insuredTripTravelCardRequest = new InsuredTripTravelCardRequest();

        insuredTripTravelCardRequest.policyNumber = this.insuredTripDetail.policyNumber;
        insuredTripTravelCardRequest.dateBegin = moment(this.insuredTripDetail.dateBegin).format('DD.MM.YYYY');
        insuredTripTravelCardRequest.dateEnd = moment(this.insuredTripDetail.dateEnd).format('DD.MM.YYYY');
        insuredTripTravelCardRequest.firstName = this.insuredTripDetail.partner.firstName;
        insuredTripTravelCardRequest.surname = this.insuredTripDetail.partner.surname;
        insuredTripTravelCardRequest.dateOfBirth = moment(this.insuredTripDetail.partner.dateOfBirth).format('DD.MM.YYYY');

        this.travelMemberService.generateTravelCard(insuredTripTravelCardRequest).subscribe((insuredTripTravelCardResponse: InsuredTripTravelCardResponse) => {
            this.travelMemberService.getTravelCart(insuredTripTravelCardResponse.uuid, true);
        });
    }

    changeEndDate() {
        let insuredTripChangeEndDateRequest = new InsuredTripChangeEndDateRequest();
        insuredTripChangeEndDateRequest.dateEnd = moment(this.formEditInsuredTrip.value.dateEnd).format('YYYY-MM-DD');
        insuredTripChangeEndDateRequest.dateBegin = moment(this.insuredTripDetail.dateBegin).format('YYYY-MM-DD');
        insuredTripChangeEndDateRequest.policyNumber = this.policyNumber;
        insuredTripChangeEndDateRequest.policyNumberTravelMember = this.policyNumberTravelMember;
        insuredTripChangeEndDateRequest.statusId = this.insuredTripDetail.statusId;

        this.travelMemberService.changeEndDate(insuredTripChangeEndDateRequest).subscribe(x => {
            localStorage.setItem('changedEndDate', "1");
            window.location.reload();
            // this.router.navigate([`/moje-poistky/${this.policyStatus}/${this.policyNumber}/poistene-cesty`]);
        });
    }

    private calculatePremium() {

        let dateBegin = this.formEditInsuredTrip.value.dateBegin;
        if (dateBegin == undefined) {
            dateBegin = this.insuredTripDetail.dateBegin;
        }

        this.insuredTripDetail.premium =
            (moment(this.formEditInsuredTrip.value.dateEnd).diff(dateBegin, 'days') + 1) * this.insuredTripDetail.rate;

        this.insuredTripDetail.premium = isNaN(this.insuredTripDetail.premium) ? 0 : this.insuredTripDetail.premium;
    }

    getHasTravelLink(travelPolicyNumber) {
        return this.commonService.getBaseHref() + `moje-poistky/${this.policyStatus}/${this.policyNumber}/poistene-cesty/${travelPolicyNumber}`;
    }
}
